import React from "react";




interface TabsProps {
  tabs: string[];
  activeTab: string;
  setActiveTab: (value: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="flex p-1 bg-neutral-200 items-center w-max rounded-full">
      {tabs.map((tab) => {
        const isActive = tab === activeTab;
        return (
          <button
            key={tab}
            className={`py-3 px-4 text-neutral-950 text-base font-semibold ${
              isActive
                ? "rounded-full bg-neutral-50"
                : "hover:text-gray-800"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
